<template lang="pug">
	.creative-voiceover
		Loader(v-if="isLoading", :text="$tCaption('Loading', '@actions')")
		Popup(v-if="voiceOverRequestPopupVisible", :popupVisible.sync="voiceOverRequestPopupVisible", :width="340", :height="230", :title="$tCaption('Request voiceover')", :autosize="true")
			.flex-col.space-medium
				Loader(v-if="isLoading", text="", :fullscreen="true")
				.flex-col.space(:class="{ 'disabled-controls': isLoading }")
					.font-small.upper.grey {{$tCaption('Email')}}
					DxTextBox(:value.sync="email", valueChangeEvent="input", stylingMode="filled")
				.flex-col.space
					.font-small.upper.grey {{$tCaption('Voiceover tracks')}}
					.flex-col.space
						.available-track(v-for="track in availableTracks", @click="() => $Data.toggleSelectedIdInArray(track.trackNumber, selectedTracks)")
							DxCheckBox(:value="selectedTracks.includes(track.trackNumber)" :text="track.name")
			template(slot="actions-right")
				DxButton(:text="$tCaption('Cancel', '@actions')", @click="voiceOverRequestPopupVisible = false")
				DxButton(:text="$tCaption('Send', '@actions')", @click="sendVoiceoverRequest", :disabled="!email || isLoading", type="default")
</template>

<script>
	import _ from 'lodash';
	import Loader from 'app-core/Loader.vue';
	import Popup from 'app-core/Popup.vue';
	import DxTextBox from 'devextreme-vue/text-box';
	import DxButton from 'devextreme-vue/button';
	import DxCheckBox from 'devextreme-vue/check-box';

	export default {
		translationCategory: 'creative.Voiceover',
		name: 'creative-voiceover',
		components: {
			Loader, Popup, DxTextBox, DxButton, DxCheckBox
		},
		props: ['creative'],
		data() {
			return {
				isLoading: false,
				voiceOverRequestPopupVisible: false,
				vastLink: null,
				email: null,
				selectedTracks: []
			};
		},
		computed: {
			availableTracks() {
				return (this.creative?.JsonConfig?.aggregatedTracks || []);
			}
		},
		mounted() {
			if (__DEBUG__)
				window.creativeVoiceover = this;
		},
		methods: {
			show() {
				this.voiceOverRequestPopupVisible = false;
				this.email = null;
				setImmediate(() => {
					if (this._isDestroyed) return;
					this.voiceOverRequestPopupVisible = true;
				});
			},
			addVoiceoverInfoToCreative(request) {
				this.creative.JsonConfig.voiceoverRequests.push({
					voiceoverRequestId: request.Oid,
					voiceoverTrackNumbers: _.cloneDeep(this.selectedTracks)
				});
			},
			sendVoiceoverRequest() {
				this.isLoading++;
				this.$Data.postExternalApi('VoiceoverRequest/CreateUpdate', {
					Email: this.email,
					Creative: {
						Oid: this.creative?.Oid
					}
				}).then(r => {
					if (r?.Success !== false) {
						this.$notifySuccess(this.$tCaption('Voiceover request has been successfully created.'));
						this.addVoiceoverInfoToCreative(r.Data);
					} else {
						this.$notifyError(r?.ErrorMessage);
					}
					return true;
				}).finally(() => this.isLoading--)
				this.voiceOverRequestPopupVisible = false;
			},
			finish(requestId) {
				if (__DEBUG__)
					console.debug('Voiceover request finish', requestId);
				this.$confirm(void 0, this.$tCaption('Do you want to finish voiceover?')).then(() => {
					const request = this.creative.JsonConfig.voiceoverRequests.find(f => f.voiceoverRequestId === requestId);
					if (!request) return;

					this.$set(request, 'completed', true);
					this.$set(request, 'completedDate', new Date());
					this.$Data.postExternalApi('VoiceoverRequest/VoiceoverCompleted', { Id: requestId }).then(r => {
						if (r?.Success !== false && !r?.ExceptionType) {
							this.$notifySuccess(this.$tCaption('Voiceover complete notification has been sent to author successfully.'));							
						} else {
							this.$notifyError(r?.ErrorMessage || r?.Message);
							request.completed = false;
						}
					});
				});
			}
		}
	};
</script>
<style lang='scss'>
	.creative-voiceover{
	}
</style>
